import { AxiosInstance, AxiosPromise } from 'axios';
import { NoteServiceEndpoints, NoteUpdateRequest, NoteUpdateResponse } from './NoteService.types';
import { Note } from '@trukt/portal-utils/Note';
import { PaginatedResults } from '@trukt/types/PaginatedResults';
import { BaseRequest } from '@trukt/types/BaseRequest';

export type OrderNoteGetRequest = BaseRequest<
  { pg: number; rc: number },
  void,
  { orderGuid: string }
>;
export type OrderNoteGetResponse = PaginatedResults<Note>;

export class NoteService implements NoteServiceEndpoints {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  getOrderNotes({ queryParams, routeParams }: OrderNoteGetRequest) {
    return this.instance.get<OrderNoteGetResponse>(`/order/${routeParams.orderGuid}/notes`, {
      params: queryParams,
    });
  }

  update(request: NoteUpdateRequest): AxiosPromise<NoteUpdateResponse> {
    return this.instance.patch<NoteUpdateResponse>(
      `/notes/${request.routeParams.id}`,
      request.body,
    );
  }
}
